import React, { useEffect, memo, Fragment, useState } from "react";
import { useLocation, Outlet, Navigate } from "react-router-dom";

// header
import Headerpro from "../../components/partials/pro/headerstyle/header-pro";
import { clearStoragePreservingReportColumns } from "../../utilities/reportColumnStorage";

//subheader
import SubHeader from "../../components/partials/dashboard/headerstyle/sub-header";

//sidebar
import Sidebar from "../../components/partials/dashboard/sidebarstyle/sidebar";

//footer
import Footer from "../../components/partials/dashboard/footerstyle/footer";

//seetingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";

import Loader from "../../components/Loader";
import MaintenanceBanner from "../../components/partials/MaintenanceBanner";

// Meridian theme layer (tokens + sidebar recolor) — loaded app-wide
import "../../theme/theme.css";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";

// Redux Selector / Action
import { useSelector } from "react-redux";
import { Suspense } from "react";

const Default = memo((props) => {
  let location = useLocation();
  const pageLayout = useSelector(SettingSelector.page_layout);
  const appName = useSelector(SettingSelector.app_name);
  const [userDetails, setUserDetails] = useState({
    role: localStorage.getItem('role'),
    iec: localStorage.getItem('iec_no'),
    name: localStorage.getItem('name'),
    token: localStorage.getItem('token')
})
  useEffect(() => {});

  // Helper: decode JWT payload without any library
  const isTokenExpired = (token) => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // exp is in seconds; Date.now() is in milliseconds
      return payload.exp * 1000 < Date.now();
    } catch {
      return true; // treat malformed token as expired
    }
  };

  if (!userDetails.token || !userDetails.role || isTokenExpired(userDetails.token)) {
    // Clear stale data so the login page starts clean
    clearStoragePreservingReportColumns();
    return <Navigate to="/" replace />;
  }

  var subHeader = "";
  var commanclass = "";
  switch (location.pathname) {
    case "/dashboard/special-pages/calender":
    case "/dashboard/special-pages/billing":
    case "/dashboard/special-pages/kanban":
    case "/dashboard/special-pages/pricing":
    case "/dashboard/special-pages/timeline":
    case "/plugins/ui-color":
    case "/dashboard/widget/widgetbasic":
    case "/dashboard/widget/widgetchart":
    case "/dashboard/widget/widgetcard":
    case "/dashboard/map/google":
    case "/dashboard/map/vector":
    case "/dashboard/form/form-element":
    case "/dashboard/form/form-wizard":
    case "/dashboard/form/form-validation":
    case "/dashboard/table/table-data":
    case "/dashboard/table/bootstrap-table":
    case "/dashboard/table/border-table":
    case "/dashboard/table/fancy-table":
    case "/dashboard/table/fixed-table":
    case "/dashboard/app/user-list":
    case "/dashboard/icon/solid":
    case "/dashboard/icon/outline":
    case "/dashboard/icon/dual-tone":
      subHeader = <SubHeader />;
      commanclass = "iq-banner default";
      break;
    default:
      break;
  }

  return (
    <Fragment>
        <Loader />
        <Sidebar app_name={appName} />
        
        <main className="main-content">
          <div className={`${commanclass} position-relative `}>
            <Headerpro />
            {subHeader}
          </div>
          <MaintenanceBanner />
          <div className={` ${pageLayout} content-inner pb-0`}>
            <Suspense fallback={<div className="react-load"></div>}>
              <Outlet></Outlet>
            </Suspense>
          </div>
          <Footer />
        </main>
        {/* <SettingOffCanvas /> */}
    </Fragment>
  );
});

Default.displayName = "Default";
export default Default;
